'use client';

import { type FC, useEffect } from 'react';
import { BaseLineClose } from '@/app/components/icons/BaseLineClose';
import { reportEvent } from '@/app/utils';

const NOTIFICATION_IMAGE = 'https://image01-aliyun.vidu.zone/vidu/media-asset/retention_notification-aab4b680.webp';

interface RetentionNotificationProps {
  onClose: () => void;
}

/**
 * Phase1 右上角挽留通知卡片
 * 用户取消自动续费后，在首页右上角展示
 */
export const RetentionNotification: FC<RetentionNotificationProps> = ({ onClose }) => {
  useEffect(() => {
    reportEvent('page_name', { subscription_reactivation: 'gt7-toast' });
  }, []);

  return (
    <div
      className="relative flex w-[300px] flex-col gap-2 overflow-hidden rounded-12 bg-[#2C323D] p-2 pb-4 text-white"
      style={{
        boxShadow: '0px 20px 60px 0px rgba(0, 0, 0, 0.32)',
        border: '1px solid #ffffff1f',
      }}
    >
      <BaseLineClose
        className="absolute top-4 right-4 cursor-pointer text-base"
        onClick={(e: React.MouseEvent) => {
          e.stopPropagation();
          onClose();
        }}
        onPointerDownCapture={(e: React.PointerEvent) => {
          e.stopPropagation();
        }}
      />
      <img src={NOTIFICATION_IMAGE} alt="" className="w-full rounded-12" />
      <div className="px-2 leading-5">
        <div className="mb-1 font-semibold text-base">你已关闭自动续费，会员将在到期后结束</div>
        <div className="font-normal text-sm">任务中心内 填写反馈问卷可领取积分奖励~</div>
      </div>
    </div>
  );
};
